import SecureLS from "secure-ls";

export const LocalStore = (key, params) => {
  var ls = new SecureLS();
  ls.set(key, params);
};

export const GetLocalStore = (key) => {
  var ls = new SecureLS();
  return ls.get(key);
};

export const RemoveLocalStore = (key) => {
  var ls = new SecureLS();
  ls.remove(key);
};

export const RemoveAllLocalStore=()=>{
  var ls = new SecureLS();
    ls.removeAll()
}


export const RemoveTreatTeamLocalStore=()=>{
  RemoveLocalStore("userDetails");
  RemoveLocalStore("lognDetails");
}

export const RemoveAdminLocalStore=()=>{
  RemoveLocalStore("path");
  RemoveLocalStore("token");
}